import { createAction } from '@reduxjs/toolkit'
import { TenantConfig } from './types'

export default {
  fetch: createAction('TENANT_CONFIG/FETCH'),
  fetchSuccess: createAction<TenantConfig>('TENANT_CONFIG/FETCH/SUCCESS'),
  fetchFail: createAction<Error>('TENANT_CONFIG/FETCH/FAIL'),
}
